"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFinDepartmentRevenueMappingSchema = exports.createFinDepartmentRevenueMappingSchema = exports.finDepartmentRevenueMappingShape = void 0;
const zod_1 = require("zod");
/** Enterprise Architecture Handbook v1.0 (OP Billing Administration, Module 3 — Department Mapping). Real hard-delete on remove — `FinancialConfigRepository`'s Pattern 4, no lifecycle field on this row. */
exports.finDepartmentRevenueMappingShape = {
    departmentId: zod_1.z.string().uuid(),
    revenueCenterId: zod_1.z.string().uuid(),
    effectiveFrom: zod_1.z.coerce.date(),
    effectiveTo: zod_1.z.coerce.date().optional(),
};
exports.createFinDepartmentRevenueMappingSchema = zod_1.z.object(exports.finDepartmentRevenueMappingShape);
exports.updateFinDepartmentRevenueMappingSchema = zod_1.z.object(exports.finDepartmentRevenueMappingShape).partial();
//# sourceMappingURL=fin-department-revenue-mapping.schema.js.map